<button type="button" class="{{styleClass}}" (click)="openDaumApi()">우편번호 찾기</button>

<div class="daum-postcode-overlay" *ngIf="layerVisible" (click)="closeLayer()">
  <div class="daum-postcode-popup" (click)="$event.stopPropagation()">
    <div class="daum-postcode-header">
      <span>우편번호 찾기</span>
      <button type="button" class="daum-postcode-close" (click)="closeLayer()" aria-label="닫기">×</button>
    </div>
    <div #postcodeLayer class="daum-postcode-body"></div>
  </div>
</div>
